import { createSlice } from '@reduxjs/toolkit';

import type { ArbitroAdmin, ArbitrosAdminState } from '@/types/arbitral/arbitroAdminTypes';

import { alterarStatusArbitro, cadastrarArbitro, fetchArbitros } from './actions';

const initialState: ArbitrosAdminState = {
  items: [],
  loading: false,
  saving: false,
  error: null,
};

const upsert = (items: ArbitroAdmin[], updated: ArbitroAdmin): ArbitroAdmin[] =>
  items.map((item) => (item.id === updated.id ? updated : item));

const arbitrosAdminSlice = createSlice({
  name: 'arbitrosAdmin',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArbitros.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArbitros.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchArbitros.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(cadastrarArbitro.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(cadastrarArbitro.fulfilled, (state, action) => {
        state.saving = false;
        state.items.unshift(action.payload);
      })
      .addCase(cadastrarArbitro.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload as string;
      })
      .addCase(alterarStatusArbitro.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(alterarStatusArbitro.fulfilled, (state, action) => {
        state.saving = false;
        state.items = upsert(state.items, action.payload);
      })
      .addCase(alterarStatusArbitro.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = arbitrosAdminSlice.actions;
export default arbitrosAdminSlice.reducer;
